export default "query getProvince {\n    getProvince\n}";